import { CustomReportStatusEnum } from "@c2b/muven-commons";
import { ReportExampleFileModel } from "./ReportExampleFileModel";

interface ReportFilter {
	date: boolean;
	stores: boolean;
	channels: boolean;
}

export class ReportModel {
	id?:number = undefined;	
	publicCustomReportId?:string = undefined;
	name: string = '';
	status: CustomReportStatusEnum = CustomReportStatusEnum.Requested;
	description: string = '';
	fileName: string = '';
	example: ReportExampleFileModel[] = [];
	filter: ReportFilter;
	loadingListAction: boolean = false;

	constructor(r?:Partial<ReportModel>) {
		Object.assign(this, r)
		this._parseExamples()
		this._parseFilter()
	}

	hasFilter():boolean {
		return this.filter.date || this.filter.channels || this.filter.stores
	}

	hasDateFilter():boolean {
		return this.filter.date
	}

	hasChannelsFilter():boolean {
		return this.filter.channels
	}

	hasStoresFilter():boolean {
		return this.filter.stores
	}

	isNew():boolean {
		return !this.id
	}

	getId():string|number|undefined {
		if (!!this.id) {
			return this.id as number
		}

		if (!!this.publicCustomReportId) {
			return `p_${this.publicCustomReportId}`
		}
		
		return undefined
	}

	isPublic():boolean {
		if (this.id) {
			return false
		} else if (!!this.publicCustomReportId) {
			return true
		}

		return false
	}

	hasExamples():boolean {
		return !!this.example.length
	}

	getStatusDescription():string {
		if (this.isStatusRequested()) {
			return 'Solicitado'
		}

		if (this.isStatusDone()) {
			return 'Pronto'
		}

		if (this.isStatusWorking()) {
			return 'Em uso'
		}

		return ''
	}

	isValid() {
		return !!this.name && 
			!!this.description &&
			!!this.fileName
	}

	isStatusRequested():boolean {
		return this.status === CustomReportStatusEnum.Requested;
	}

	isStatusWorking():boolean {
		return this.status === CustomReportStatusEnum.Working;
	}

	isStatusDone():boolean {
		return this.status === CustomReportStatusEnum.Done;
	}

	private _parseExamples():void {
		this.example = (this.example || []).map((ex) => new ReportExampleFileModel(ex))
	}

	private _parseFilter():void {
		if (!this.filter) {
			this.filter = {
				date: false,
				stores: false,
				channels: false,
			}
		}
	}
}
